import { PayloadAction } from "@reduxjs/toolkit";
import { ReduxHelper } from "helpers";
import { IBaseReducerState } from "helpers/reduxHelpers";
import { IdentityActions, WarehouseActions } from "redux/actions";

interface IWarehouseState extends IBaseReducerState {}

const initialState: IWarehouseState = {
  action: WarehouseActions.prefix + "/",
  prefix: WarehouseActions.prefix,
};

const clearAction = (state: IWarehouseState, action: PayloadAction) =>
  ReduxHelper.handleReducerBuilder(state, action, () => {
    state.action = WarehouseActions.prefix + "/";
  });

const logout = (state: IWarehouseState, action: PayloadAction) =>
  ReduxHelper.handleReducerBuilder(state, action, () => {
    state.action = WarehouseActions.prefix + "/";
  });

const UserReducer = ReduxHelper.createHandleReducer<IWarehouseState>(
  initialState,
  (builder) => {
    builder

      .addCase(WarehouseActions.clearAction.request, clearAction)
      .addCase(IdentityActions.logout.request, logout);
  }
);

export default UserReducer;
